import React, {useState} from 'react';
import {useTheme} from '../../../../utils/theming/themeProvider';
import {SwitchProps} from './switch_types.web';
import {styles} from './switch_styles.web';

const Switch = (props: React.PropsWithChildren<SwitchProps>) => {
  const {
    id,
    className,
    state = 'enable',
    size = '32',
    isActive = false,
    containerStyle,
    text,
    onChange,
  } = props;
  const [isHovered, setIsHovered] = useState(false);

  const [active, setActive] = useState(isActive);

  const {colors, fontStyles} = useTheme();

  const currentState =
    state === 'enable' ? (isHovered ? 'hover' : 'enable') : state;

  const borderWidth = size === '32' ? 3 : 2.25;
  const width = (size === '32' ? 52 : 39) - borderWidth * 2;
  const circleSize = size === '32' ? 26 : 20;

  const dynamicStyles = styles(
    width,
    currentState,
    circleSize,
    borderWidth,
    active,
    colors,
    fontStyles,
    size,
  );

  return (
    <div
      id={id}
      className={className}
      style={{...dynamicStyles.switchContainer, ...containerStyle}}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => {
        if (state !== 'disable') {
          setActive(!active);
          onChange(!active);
        }
      }}>
      {text && <span style={dynamicStyles.text}>{text}</span>}
      <div style={dynamicStyles.switch}>
        <div style={dynamicStyles.switchCircle} />
      </div>
    </div>
  );
};

export default Switch;
